<template>
	<div class="page board 2">
		<!-- board -->
		<section class="secWrap boardWrap">
			<div class="topBgWrap commonImg" :style="topBgStyle"></div>
			<div class="pageContentWrap">
				<div class="pageInnerContentHtmlWrap">
					<div class="pageHeaderImg" v-if="this.receivedData.mainImg">
						<img
							:src="$store.getters.getUrlPrefix + this.receivedData.mainImg"
							alt=""
						/>
					</div>
					<!-- 컴포넌트 및 html 자리 -->
					<h3 v-if="this.receivedData.title" class="pageTitle">
						{{ this.receivedData.title }}
					</h3>
					<p>No. {{ this.receivedData.boardNo }}</p>
					<div class="pageHtml" v-html="this.receivedData.content"></div>
				</div>
				<div class="pagingBtnsWrap">
					<router-link
						class="btn btnPrev"
						v-show="receivedData.prev"
						:to="
							'/boardview?board=' +
								receivedData.cate +
								'&boardNo=' +
								receivedData.prev
						"
						>이전</router-link
					>
					<router-link class="btn btnList" :to="boardName">목록</router-link>
					<router-link
						class="btn btnNext"
						v-show="receivedData.next"
						:to="
							'/boardview?board=' +
								receivedData.cate +
								'&boardNo=' +
								receivedData.next
						"
						>다음</router-link
					>
				</div>
			</div>
		</section>
		<Footer />
	</div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "../components/Footer";

export default {
	name: "board",
	components: {
		Footer
	},
	data() {
		return {
			board: {
				background: {
					color: "#fff",
					// image: require('@/assets/images/temp-board-top-img@2x.jpg'),
					image: "",
					size: "cover",
					position: "center center",
					width: "100%"
					// height: '284px'
				},
				htmlData: {
					// image: require('@/assets/images/temp-board-top-img@2x.jpg'),
					image: "",
					title: "푸르덴셜생명 모바일 명의 변경(다건) 시스템 구축",
					html:
						"푸르덴셜생명의 구 시스템에 최초로 다건 시스템을 개발하여<br>명의변경 시스템에 반영, 개편하고 있습니다.<br>전자신청서 및 리모트 서비스 개발 iPad 모바일 서비스 확대<br>사이버창구 개편<br>안내장 카카오 인증기반 전자우편 발송<br>변액 수액율 안내<br>전자약관 발송 시스템 도입<br>FDS 이상금융거래 탐지 연계<br><br>최선을 다하는 두손소프트의 모습을 지켜봐주시고,<br>응원해주시기 바랍니다.<br><br>감사합니다."
				}
			},
			receivedData: {
				/*
				cate: 'news',
				boardNo: '16',
				mainImg: require('@/assets/images/temp-news-item-1@2x.png'),
				title: '푸르덴셜생명 모바일 명의 변경(다건) 시스템 구축',
				shortCont: '푸르덴셜생명의 구 시스템에 최초로 다건 시스템을 개발하여<br>명의변경 시스템에 반영, 개편하고 있습니다.',
				content: '푸르덴셜생명의 구 시스템에 최초로 다건 시스템을 개발하여<br>명의변경 시스템에 반영, 개편하고 있습니다.',
				registDt: '2020.04.02',
				link: '',
				prev: 16,
				next: 14
				*/
			}
		};
	},
	computed: {
		boardName: function() {
			return this.$route.query.board ? this.$route.query.board : "/";
		},
		topBgStyle: function() {
			var bgUrl = this.receivedData.mainImg
				? this.receivedData.mainImg
				: this.board.background.image;
			return {
				backgroundColor: this.board.background.color,
				backgroundImage:
					"url('https://www.twosonsoft.com/resources/img/bg-board-common.png')",
				// height: this.board.background.height,
				width: this.board.background.width,
				backgroundSize: this.board.background.size
					? this.board.background.size
					: "cover",
				backgroundPosition: this.board.background.position
					? this.board.background.position
					: "center center"
			};
		}
	},
	watch: {
		receivedData: {
			deep: true,
			immediate: true,
			handler() {
				/* console.log('The page data has changed!') */
			}
		}
	},
	mounted() {
		var no = this.$route.query.boardNo;
		this.$axios
			.post(this.$store.state.dataUrl + "/twosonBoard?no=" + no)
			.then(response => {
				console.log("newsPage : ", response.data);
				this.receivedData = response.data;
			})
			.catch(error => {
				console.log("* error : " + error.response);
			});
	},
	created() {
		AOS.init({
			duration: 600,
			easing: "ease-in-sine",
			delay: 100
		});
	},
	destroyed() {},
	methods: {}
};
</script>

<style lang="scss">
@import "@/css/variables.scss";
.board {
	.boardWrap {
		.pageContentWrap {
			.pageInnerContentHtmlWrap {
				$pd: 40px;
				.top,
				.right,
				.bottom,
				.left {
					position: absolute;
				}
				.pageTitle {
					font-size: $title-small;
				}
				.pageHeaderImg {
					img {
						width: 100%;
						display: block;
					}
					&.top {
						top: $pd/2;
					}
					&.right {
						right: $pd/2;
					}
					&.bottom {
						bottom: $pd/2;
					}
					&.left {
						left: $pd/2;
					}
				}
				.pageHtml {
					img {
						margin: 0 auto;
						display: block;
					}
				}
			}
		}
	}
}
</style>

<style lang="scss" scoped>
@import "@/css/variables.scss";
.board {
	position: relative;
	padding-top: 88px;
	height: auto;
	width: 100%;
	background-color: $c-white;
	.boardWrap {
		position: relative;
		width: 100%;
		margin: 0 auto;
		padding: 0;
		.topBgWrap {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			/* height: 284px; */
			height: 400px;
			opacity: 0.3;
			z-index: 0;
		}
		.pageContentWrap {
			position: relative;
			margin: 0 auto;
			.pageInnerContentHtmlWrap {
				padding-top: 40px;
				padding-bottom: 80px;
				min-height: 600px;
				/* page content area */
			}
			.pagingBtnsWrap {
				display: flex;
				justify-content: space-between;
				margin-bottom: 80px;
				.btn {
					width: 25%;
					padding: 16px 0;
					text-align: center;
					font-size: $text-normal;
					border: 1px solid $c-gray-m;
					color: $c-gray-black;
					font-weight: bold;
					&.btnList {
						background-color: $c-gray-bright;
					}
				}
			}
		}
	}
	.btnMore {
		display: block;
		width: 100%;
		height: 90px;
		text-align: center;
		font-size: $text-medium;
		color: $c-white;
		background-color: $c-gray-m;
		.icon {
			margin-left: 8px;
		}
	}
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	.board {
		padding-top: 74px;
		.boardWrap {
			.topBgWrap {
				height: 160px;
				opacity: 0.2;
			}
			.topBgWrap.commonImg {
				background-image: url("https://www.twosonsoft.com/resources/img/bg-board-common.png") !important;
			}
			.pageContentWrap {
				.pageInnerContentHtmlWrap {
					padding: 40px 12px 60px 12px;
					min-height: 600px;
					/* page content area */
					.pageTitle {
						margin: 20px 0;
						font-size: $title-normal-small;
						letter-spacing: $lspace-short;
					}
				}
				.pagingBtnsWrap {
					margin-bottom: 40px;
					.btn {
						padding: 10px 0;
						font-size: $text-small;
					}
				}
			}
		}
	}
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
	//CSS
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/

@media (min-width: 481px) and (max-width: 767px) {
	//CSS
	.board {
		padding-top: 74px;
		.boardWrap {
			.topBgWrap {
				max-height: 156px;
				opacity: 0.2;
			}
			.pageContentWrap {
				.pageInnerContentHtmlWrap {
					padding: 40px 12px 60px 12px;
					min-height: 600px;
					/* page content area */
					.pageTitle {
						margin: 20px 0 10px;
						font-size: $title-xxsmall;
						letter-spacing: $lspace-short;
					}
				}
				.pagingBtnsWrap {
					padding: 0 12px;
					margin-bottom: 0px;
					position: fixed;
					bottom: 10px;
					left: 0;
					width: 100%;
					z-index: 1;
					.btn {
						padding: 8px 0;
						font-size: $text-small;
						background-color: #fff;
					}
				}
			}
		}
	}
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
	.board {
		padding-top: 74px;
		.boardWrap {
			.topBgWrap {
				max-height: 156px;
				opacity: 0.2;
			}
			.pageContentWrap {
				.pageInnerContentHtmlWrap {
					padding: 40px 12px 60px 12px;
					min-height: 600px;
					/* page content area */
					.pageTitle {
						margin: 20px 0 10px;
						font-size: $title-xxsmall;
						letter-spacing: $lspace-short;
					}
				}
				.pagingBtnsWrap {
					padding: 0 12px;
					margin-bottom: 0px;
					position: fixed;
					bottom: 10px;
					left: 0;
					width: 100%;
					z-index: 1;
					.btn {
						padding: 8px 0;
						font-size: $text-small;
						background-color: #fff;
					}
				}
			}
		}
	}
}
</style>
